import * as pdfjs from 'pdfjs-dist';

(pdfjs as any).GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";//here mention the node modules if the download works

export const pdfjsLib = pdfjs;
